import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RestaurantPage from './pages/RestaurantPage';
import EtangsPage from './pages/EtangsPage';
import ContactPage from './pages/ContactPage';
import GaleriePage from './pages/GaleriePage';
import TarifsPage from './pages/TarifsPage';
import NotFoundPage from './pages/NotFoundPage';
import Layout from './components/layout/Layout';
import LoadingScreen from './components/LoadingScreen';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Préchargement simple du site
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Durée de l'écran de chargement en millisecondes

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/restaurant" element={<RestaurantPage />} />
            <Route path="/etangs" element={<EtangsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/galerie" element={<GaleriePage />} />
            <Route path="/tarifs" element={<TarifsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
    </>
  );
}

export default App;
